/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../constants';
import axios from "axios";
import Select from 'react-select';
import config from '../../../config/config';
import TileComp from '../../ProcureToPayComp/TileComp/TileComp';
import styles from './TransitionPOStatusComp.module.css';
import './TransitionPOStatusComp.css';
import OverallTransitionSummaryCharts from '../OverallTransitionSummaryCharts/OverallTransitionSummaryCharts';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import HorizontalProgressChart from '../HorizontalProgressChart/HorizontalProgressChart';
import ReusableTable from '../../ReusableTable/ReusableTable';

import EntityStatusComparisonChart from '../EntityStatusComparisonChart/EntityStatusComparisonChart';
import TitleWithDetailedClick from '../TitleWithDetailedClick/TitleWithDetailedClick';

import SimpleBarChart from '../simpleChart/simpleChart';

const { API_BASE_URL } = config;

const TransitionPOStatusComp = () => {

  const { showPopup } = usePopupManager();
  const location = useLocation();
  const initialFilters = location.state || {
    inOutData: [],
    locationData: [],
    subDivisionData: [],
    yearData: [],
    quarterData: [],
  };

  const [filters, setFilters] = useState(initialFilters);
  const [showDashboard, setShowDashboard] = useState(false);
  const [showMainDashboard, setShowMainDashboard] = useState(false);
  const [detailedButtonClick, setDetailedButtonClick] = useState(false);

  const [InOutOptions, setInOutOptions] = useState([]);
  const [LocationOptions, setLocationOptions] = useState([]);
  const [SubDivisionOptions, setSubDivisionOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [quarterOptions, setQuarterOptions] = useState([]);
  const [entityOptions, setEntityOptions] = useState([]);
  const [InOut, setInOut] = useState([]);
  const [Location, setLocation] = useState([]);
  const [SubDivision, setSubDivision] = useState([]);
  const [Year, setYear] = useState([]);
  const [Quarter, setQuarter] = useState([]);
  const [overall, setOverall] = useState([]);
  // const [entity, setEntity] = useState([entityOptions[0]]);
  const [entity, setEntity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [POReceived, setPOReceived] = useState([]);
  const [POPending, setPOPending] = useState([]);
  const [POReceivedSum, setPOReceivedSum] = useState([]);
  const [POPendingSum, setPOPendingSum] = useState([]);
  const [OverAllPOStatus, setOverAllPOStatus] = useState([]);
  const [POStatusDetailTable, setPOStatusDetailTable] = useState([]);
  const [POStatusDetailTableCount, setPOStatusDetailTableCount] = useState([]);
  const [POStatusDetailTableCSV, setPOStatusDetailTableCSV] = useState([]);
  const [POActualVsBudgetedFTE, setPOActualVsBudgetedFTE] = useState([]);
  const [EntityWiseDrillDownData, setEntityWiseDrillDownData] = useState([]);
  const [TowerWiseDrillDownData, setTowerWiseDrillDownData] = useState([]);

  const [hasApplied, setHasApplied] = useState(false);

  const [towerOptions, settowerOptions] = useState([]);
  const [towerselected, settowerselected] = useState([]);

  const [PONumberOptions, setPONumberOptions] = useState([]);
  const [PONumberselected, setPONumberselected] = useState([]);

  const [selectedPage, setSelectedPage] = useState();

  const [startPage, setStartPage] = useState(0);
  const [endPage, setEndPage] = useState(100);

  const [selectedEntityName, setSelectedEntityName] = useState([]);
  const [selectedTowerName, setselectedTowerName] = useState([]);

  const [actualStatusselected, setactualStatusselected] = useState([]);
  const [actualstatusOptions, setactualstatusOptions] = useState([]);

  const [transitionLeadselected, settransitionLeadselected] = useState([]);
  const [transitionLeadOptions, settransitionLeadOptions] = useState([]);

  const itemsPerPage = 100;

  const handleInOutChange = (selected) => {
    // setInOut(selected);
    setInOut(selected || []);
    setFilters(prev => ({ ...prev, inOutData: selected }));
  };

  const handleLocationChange = (selected) => {
    // setLocation(selected);
    setLocation(selected || []);
    setFilters(prev => ({ ...prev, locationData: selected }));
  };

  const handleSubDivisionChange = (selected) => {
    // setSubDivision(selected);
    setSubDivision(selected || []);
    setFilters(prev => ({ ...prev, subDivisionData: selected }));
  };

  // const handleYearChange = (selected) => {
  //   // setYear(selected);
  //   setYear(selected || []);
  //   setFilters(prev => ({ ...prev, yearData: selected }));
  // };

  // const handleYearChange = (selected) => {
  //   const updatedYear = selected || [];
  //   setYear(updatedYear);
  //   setFilters(prev => ({ ...prev, yearData: updatedYear }));

  //   if (updatedYear.length === 0) {
  //     setQuarter([]);
  //     setFilters(prev => ({ ...prev, quarterData: [] }));
  //   }
  // };

  const handleYearChange = (selected) => {
    if (!selected) {
      setYear([]);
      setQuarter([]);
      setFilters(prev => ({ ...prev, yearData: [], quarterData: [] }));
      return;
    }
    const updatedYear = [selected];
    setYear(updatedYear);
    setFilters(prev => ({ ...prev, yearData: updatedYear }));
    setQuarter([]);
    setFilters(prev => ({ ...prev, quarterData: [] }));
  };

  const handleQuarterChange = (selected) => {
    // setQuarter(selected);
    setQuarter(selected || []);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };

  const handleTowerChange = (selected) => {
    const selectedArray = selected || [];
    settowerselected(selected || []);
    setFilters(prev => ({ ...prev, towerData: selected }));
    const selectedtowerNames = selectedArray.map(e => e.label);
    setselectedTowerName(selectedtowerNames.join(', '));
};

  const handlePO_NumberChange = (selected) => {
    const selectedArray = selected || [];
    setPONumberselected(selected || []);
    setFilters(prev => ({ ...prev, towerData: selected }));
    // const selectedtowerNames = selectedArray.map(e => e.label);
    // settowerselected(selectedtowerNames.join(', '));
};

const handleActualStatusChange = (selected) => {
  // setLocation(selected);
  setactualStatusselected(selected || []);
  setFilters(prev => ({ ...prev, locationData: selected }));
};

const handleTransitionLeadChange = (selected) => {
  // setLocation(selected);
  settransitionLeadselected(selected || []);
  setFilters(prev => ({ ...prev, locationData: selected }));
};

  const fetchInOutOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-in-out`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setInOutOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchLocationOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-location`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setLocationOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchSubDivisionOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-sub-division`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setSubDivisionOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchQuerterOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-quarter`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setQuarterOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-entity`, {
        headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' },
      });
      const data = response.data || [];
      setEntityOptions(data);
      // if (data.length > 0) {
      //   setEntity([data[0]]);
      //   setSelectedEntityName(data[0].label);
      // }
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchTowerOptions = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/transition-tower`, {
            headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
        })
            .then((response) => {
                settowerOptions(response.data);
            })
    } catch (error) {
        console.error('Error fetching entity options:', error);
    }
};

  const fetchPO_NumberOptions = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/transition-PO-Number`, {
            headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
        })
            .then((response) => {
                setPONumberOptions(response.data);
            })
    } catch (error) {
        console.error('Error fetching entity options:', error);
    }
};

const fetchActualstatusOptions = async () => {
  try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-Actual-status`, {
          headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
      })
          .then((response) => {
              setactualstatusOptions(response.data);
          })
  } catch (error) {
      console.error('Error fetching entity options:', error);
  }
};

const fetchTransitionLeadOptions = async () => {
  try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-transition-lead`, {
          headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
      })
          .then((response) => {
            settransitionLeadOptions(response.data);
          })
  } catch (error) {
      console.error('Error fetching entity options:', error);
  }
};

  useEffect(() => {
    fetchInOutOptions();
    fetchLocationOptions();
    fetchSubDivisionOptions();
    fetchYearOptions();
    fetchQuerterOptions();
    fetchEntityOptions();
    fetchTowerOptions();
    fetchPO_NumberOptions();
    fetchActualstatusOptions();
    fetchTransitionLeadOptions();
    // console.log("main page filter check -------------->", filters);
  }, []);

 const handleApply = () => {
    // if (Year.length === 0) {
    //   showPopup({
    //     type: MESSAGE_TYPE.INFORMATION,
    //     contextText: MESSAGE_TYPE.INFORMATION,
    //     info: "Please select a Financial Year",
    //   });
    //   return;
    // }
    // if (InOut?.length > 0 || Location?.length > 0 || SubDivision?.length > 0 || Year?.length > 0 || Quarter?.length > 0) {
    const selectedEntity = entity.map(e => e.value);
    const inoutFilterData = InOut.map(e => e.value);
    const locationFilterData = Location.map(e => e.value);
    const subDivisionFilterData = SubDivision.map(e => e.value);
    const yearFilterData = Year.map(e => e.value);
    const quarterData = Quarter.map(e => e.value);
    const TOWERS = towerselected.map(e => e.value);
    const po_number = PONumberselected.map(e => e.value);
    const actualStatus = actualStatusselected.map(e => e.value);
    const transitionLead = transitionLeadselected.map(e => e.value);

    setIsLoading(true);

    const fetchTransitionFirst = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/transition-po-status`,
          {
            selectedInout: inoutFilterData,
            selectedLocation: locationFilterData,
            selectedEntity: selectedEntity,
            selectedSubDiv: subDivisionFilterData,
            selectedYear: yearFilterData,
            selectedQuarter: quarterData,
            selectedTower:TOWERS,
            selectedPONumber:po_number,
            selectedActualstatus: actualStatus,
            selectedTranLead: transitionLead,
            start: startPage,
            end: endPage,
          },
          {
            headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' }
          }
        );

        const data = response.data;
        setPOPending(data.POStatusTileData.PO_Pending_Count);
        setPOReceived(data.POStatusTileData.PO_Received_Count);
        setPOPendingSum(data.POStatusTileData.PO_Pending_Sum);
        setPOReceivedSum(data.POStatusTileData.PO_Received_Sum);
        setOverAllPOStatus(data.OverAllPOStatusData);
        setPOStatusDetailTable(data.POStatusDetailTableData.tableData);
        setPOStatusDetailTableCount(data.POStatusDetailTableData.tableCount);
        setPOStatusDetailTableCSV(data.POStatusDetailTableData.tableCSV);
        setPOActualVsBudgetedFTE(data.POActualVSBudgetedFTEData);
        setEntityWiseDrillDownData(data.POEntityWiseDrillDownData);
        setTowerWiseDrillDownData(data.POTowerWiseDrillDownData);
      } catch (error) {
        console.error('Error fetching total tiles data:', error);
      }
    };

    Promise.all([
      fetchTransitionFirst(),
    ]).then(() => {
      if (detailedButtonClick === false) {
        setShowDashboard(true);
        setShowMainDashboard(true);
        setDetailedButtonClick(false);
        setIsLoading(false);
      } else {
        setDetailedButtonClick(true);
        setShowMainDashboard(false);
        setShowDashboard(true);
        setIsLoading(false);
      }
    });
    // }
    // else {
    //   showPopup({
    //     type: MESSAGE_TYPE.INFORMATION,
    //     contextText: MESSAGE_TYPE.INFORMATION,
    //     info: "Please select atleast one filter value.",
    //   });
    // }
  };


  const handleReset = () => {
    setInOut([]);
    setLocation([]);
    setSubDivision([]);
    setYear([]);
    setEntity([]);
    setQuarter([]);
    settowerselected([])
    setPONumberselected([])
    setSelectedEntityName([]);
    setselectedTowerName([]);
    setactualStatusselected([]);
    settransitionLeadselected([]);
    setFilters({
      inOutData: [],
      locationData: [],
      subDivisionData: [],
      yearData: [],
      quarterData: [],
    });
    setHasApplied(false);
    setShowDashboard(false);
    setShowMainDashboard(false);
    setDetailedButtonClick(false);
    setSelectedPage(1);
    setStartPage(0);
    setEndPage(100);
  };

  const handleEntity = (selected) => {
    const selectedArray = selected || [];
    setEntity(selectedArray);
    const selectedEntityNames = selectedArray.map(e => e.label);
    setSelectedEntityName(selectedEntityNames.join(', '));
  };

  useEffect(() => {
    setOverall({ value: 'overall', label: 'Overall summary' });
  }, []);

  const customStylesMultiSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const PoLabels = OverAllPOStatus.map(i => i[0]);
  const PoValues = [
    {
      label: "FTE's Count",
      data: OverAllPOStatus.map(i => i[1]),
      backgroundColor: [
        'rgb(54, 162, 235)',
        'rgb(255, 99, 132)',
        'rgb(75, 192, 192)',
      ],
      borderColor: [
        'rgb(54, 162, 235)',
        'rgb(255, 99, 132)',
        'rgb(75, 192, 192)',
      ],
      borderWidth: 1,
    }
  ]

  const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
  const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
  const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
  const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
  const emeraldGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';
  const varinceGradient = 'linear-gradient(135deg, #EC4899 0%, #d595b5ff 100%)';

  const columns = [
    { header: "Legal_Entity", accessor: "Legal_Entity" },
    { header: "Tower", accessor: "Tower" },
    { header: "Work Area", accessor: "Work_Area" },
    { header: "TML__EXCOM_APPROVAL_JLR_UK__Subsidiaries__PO_Approval", accessor: "TML__EXCOM_APPROVAL_JLR_UK__Subsidiaries__PO_Approval" },
    { header: "EXCOM_Approval_Date", accessor: "EXCOM_Approval_Date" },
    { header: "PO_Number", accessor: "PO_Number" },
    { header: "Actual_FTE_Nos", accessor: "Actual_FTE_Nos" },
    { header: "Yearly_Billing_Rs_in_Lacs", accessor: "Yearly_Billing_Rs_in_Lacs" },
    { header: "Actual_Status", accessor: "Actual_Status" },
  ];

  const columnsDetailed = [
    { header: "Legal_Entity", accessor: "Legal_Entity" },
    { header: "Tower", accessor: "Tower" },
    { header: "Work Area", accessor: "Work_Area" },
    { header: "TML__EXCOM_APPROVAL_JLR_UK__Subsidiaries__PO_Approval", accessor: "TML__EXCOM_APPROVAL_JLR_UK__Subsidiaries__PO_Approval" },
    { header: "EXCOM_Approval_Date", accessor: "EXCOM_Approval_Date" },
    { header: "PO_Number", accessor: "PO_Number" },
    { header: "Actual_FTE_Nos", accessor: "Actual_FTE_Nos" },
    { header: "Yearly_Billing_Rs_in_Lacs", accessor: "Yearly_Billing_Rs_in_Lacs" },
    { header: "Actual_Status", accessor: "Actual_Status" },
  ];

  // const handlePageChange = (page) => {
  //   setSelectedPage(page);
  //   console.log(`Selected page: ${page}`);
  // };

  const handlePageChange = (page) => {
    setHasApplied(true)
    setSelectedPage(page);
    let endPageVal = page * 100
    let startPageVal = endPageVal - 99

    setStartPage(startPageVal)
    setEndPage(endPageVal)
    // console.log(`Selected page: ${page}`);

  };

  useEffect(() => {
    if (hasApplied) {
      handleApply();
    }
  }, [selectedPage,hasApplied]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [dataLoading, setdataLoading] = useState(false);

  const handleCSVDownload = () => {
    const csvHeader = columns.map(col => col.header).join(',');
    const csvRows = POStatusDetailTableCSV.map(row =>
      columns.map(col => `"${(row[col.accessor] || '').replace(/"/g, '""')}"`).join(',')
    );
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Transition_PO_status.csv';
    link.click();
  };

  const labelsDetailedEntityWiseChart = POActualVsBudgetedFTE.map(i => i[0]) || EntityWiseDrillDownData.map(i => i[0]);

  const entityActualFTEs = {
    label: "Actual FTEs",
    data: EntityWiseDrillDownData.map(i => i[1]),
    backgroundColor: "#1f77b4",
  }
  const entityBudgetedFTEs = {
    label: "Budgeted FTEs",
    data: EntityWiseDrillDownData.map(i => i[2]),
    backgroundColor: "#ff7f0e",
  }

  const actualFTEs = {
    label: "Actual FTE's",
    data: POActualVsBudgetedFTE.map(i => i[1]),
    backgroundColor: "#00b588",
  }

  const budgetedFTEs = {
    label: "Budgeted FTE's",
    data: POActualVsBudgetedFTE.map(i => i[2]),
    backgroundColor: "#a4038e",
  }

  const towerWiseOverallLabels = TowerWiseDrillDownData.map(i => i[0])

  const towerWiseOverallActual = {
    label: "Actual FTE's",
    data: TowerWiseDrillDownData.map(i => i[1]),
    backgroundColor: "#00b588",
  }

  const towerWiseOverallBudgeted = {
    label: "Budgeted FTE's",
    data: TowerWiseDrillDownData.map(i => i[2]),
    backgroundColor: "#a4038e",
  }

  const handleDetailClick = () => {
    setDetailedButtonClick(true);
    setShowMainDashboard(false);
  }

  const handleMainPageClick = () => {
    setDetailedButtonClick(false);
    setShowMainDashboard(true);
  }

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>IN/OUT</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={InOut}
                onChange={handleInOutChange}
                options={InOutOptions}
                closeMenuOnSelect={false}
                isMulti
                isSearchable={true}
                placeholder="Select IN/OUT"
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Location</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Location}
                onChange={handleLocationChange}
                options={LocationOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Location"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Legal Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                placeholder={<div className="select-placeholder-text">Select Legal Entity</div>}
                onChange={handleEntity}
                options={entityOptions}
                // isSearchable={false}
                isMulti
                isSearchable={true}
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Sub-Division</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={SubDivision}
                onChange={handleSubDivisionChange}
                options={SubDivisionOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Sub-Division"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Tower</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={towerselected}
                onChange={handleTowerChange}
                options={towerOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Tower"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
        </div>
        <div className={styles.filter_panel_row} style={{ paddingTop: "10px" }}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Financial Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Year}
                onChange={handleYearChange}
                options={yearOptions}
                // isMulti
                isSearchable={true}
                placeholder="Select Financial Year"
                // closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Quarter}
                onChange={(selected) => {
                  if (Year.length === 0) {
                    showPopup({
                      type: MESSAGE_TYPE.INFORMATION,
                      contextText: MESSAGE_TYPE.INFORMATION,
                      info: "Please select Financial Year first before selecting Quarter.",
                    });
                    return;
                  }
                  handleQuarterChange(selected);
                }}
                options={quarterOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Quarter"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
                isDisabled={Year.length === 0}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>PO Status</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={PONumberselected}
                onChange={handlePO_NumberChange}
                options={PONumberOptions}
                isMulti
                isSearchable={true}
                placeholder="Select PO Number"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Actual status</label>
              <div className={styles.filter_select_wrapper}>
                  <Select
                      value={actualStatusselected}
                      onChange={handleActualStatusChange}
                      options={actualstatusOptions}
                      isMulti
                      isSearchable={true}
                      placeholder="Actual Status"
                      closeMenuOnSelect={false}
                      styles={customStylesMultiSelect}
                  />
              </div>
          </div>
          <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Transition Lead</label>
              <div className={styles.filter_select_wrapper}>
                  <Select
                      value={transitionLeadselected}
                      onChange={handleTransitionLeadChange}
                      options={transitionLeadOptions}
                      isMulti
                      isSearchable={true}
                      placeholder="Transition Lead"
                      closeMenuOnSelect={false}
                      styles={customStylesMultiSelect}
                  />
              </div>
          </div>
          <div className={styles.filter_panel_col}>
            <div className={styles.filter_select_wrapper}>
              <div className="filter-panel-col">
                <button onClick={handleApply} className="btn apply-btn">
                  Apply
                </button>
                <button onClick={handleReset} className="btn reset-btn">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>

          </div>
        </div>
      )}
      {showDashboard && (
        <>
          <div>
            {showMainDashboard && (
              <div>
                <TitleWithDetailedClick
                  // title="Overall PO Summary"
                  title={selectedEntityName && selectedTowerName ? `${selectedEntityName}  ${selectedTowerName} PO Summary` : " Overall PO Summary"}
                  handleDetailClick={handleDetailClick}
                />
                <div className="row">
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Overall PO Status" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                      <SimpleBarChart
                        labels={PoLabels}
                        dataValues={PoValues}
                        height={400}
                      />
                    </DashboardSection>
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <TileComp
                          title="PO Received FTE's Count"
                          number={POReceived}
                          gradient={paidOnTimeGradient}
                          showDownload={false}
                          popupContent="This Metric Mannual CSV Data."
                        />
                      </div>
                      <div className="col-md-6">
                        <TileComp
                          title="PO Pending FTE's Count"
                          number={POPending}
                          gradient={blueGradient}
                          showDownload={false}
                          popupContent="This Metric Mannual CSV Data."
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <TileComp
                          title="PO Received in Lac's (Approx. Value)"
                          number={`${POReceivedSum} ₹`}
                          gradient={purpleGradient}
                          showDownload={false}
                          popupContent="This Metric Mannual CSV Data."
                        />
                      </div>
                      <div className="col-md-6">
                        <TileComp
                          title="PO Pending in Lac's (Approx. Value)"
                          number={`${POPendingSum} ₹`}
                          gradient={emeraldGradient}
                          showDownload={false}
                          popupContent="This Metric Mannual CSV Data."
                        />
                      </div>
                    </div>
                    <div className="row">
                      <DashboardSection title="Budgeted vs Actual FTE by Phase" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                        <div>
                          {/* <HorizontalProgressChart data={chartDataProgress} /> */}
                          <HorizontalProgressChart
                            labels={labelsDetailedEntityWiseChart}
                            actualFTEs={actualFTEs}
                            budgetedFTEs={budgetedFTEs}
                            heightValues={150}
                          />
                        </div>
                      </DashboardSection>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-12">
                    <DashboardSection title="PO Status Details" disableDetailView={true} detailPath="" infoIcondata="Mannual CSV Data">
                      <ReusableTable
                        data={POStatusDetailTable} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={POStatusDetailTableCount} handleCSVDownload={handleCSVDownload} currentPage={selectedPage ? selectedPage - 1 : 0} 
                      />
                    </DashboardSection>
                  </div>
                </div>
              </div>
            )}
            {/* after click on detailed page */}
            {detailedButtonClick && (
              <div>
                <TitleWithDetailedClick
                  title="Detailed View"
                  handleBackClick={handleMainPageClick}
                  showBackButton={true}
                  showDetailedButton={false}
                />
                <div className="row">
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Entity wise Drilldown" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                      <EntityStatusComparisonChart
                        labels={labelsDetailedEntityWiseChart}
                        actualFTEs={entityActualFTEs}
                        budgetedFTEs={entityBudgetedFTEs}
                      />
                    </DashboardSection>
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Tower Wise Overall Status" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                      <div>
                        {/* <HorizontalProgressChart data={chartDataProgress} /> */}
                        <HorizontalProgressChart
                          labels={towerWiseOverallLabels}
                          actualFTEs={towerWiseOverallActual}
                          budgetedFTEs={towerWiseOverallBudgeted}
                          heightValues={250}
                        />
                      </div>
                    </DashboardSection>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-12 mb-3">
                    <DashboardSection title="PO Status Details" disableDetailView={true} detailPath="" infoIcondata="Mannual CSV Data">
                      <ReusableTable
                        data={POStatusDetailTable} columns={columnsDetailed} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={POStatusDetailTableCount} handleCSVDownload={handleCSVDownload} currentPage={selectedPage ? selectedPage - 1 : 0} 
                      />
                    </DashboardSection>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default TransitionPOStatusComp;
